import { scaleTime, scaleLinear, extent } from 'd3';
import { USDCurrencyCompactFormatter } from 'Helpers/Formats';

const mapResourceToChartDataPoint = (r, xAttr = 'date', yAttr = 'value') => ({
  x: (new Date(r.attr(xAttr))).getTime(),
  y: Number(r.attr(yAttr)),
  modelChangeEvents: r.attr('modelChangeEvents'),
});

export const USDFormatter = (v) => USDCurrencyCompactFormatter.format(v);
export const percentageFormatter = (v) => `${v}%`;

export default function useChartDataFromResource({
  resource,
  dataAttributes = [],
  yAxisTickFormatter,
}) {
  const chartData = {};

  let xAxisArgs = {
    dataKey: 'x',
    type: 'number',
    domain: ['auto', 'auto'],
    ticks: [],
    scale: 'auto',
  };

  let yAxisArgs = {
    dataKey: 'y',
    type: 'number',
    domain: ['auto', 'auto'],
    ticks: [],
    tickFormatter: yAxisTickFormatter,
    scale: 'auto',
  };

  function processData() {
    if (!resource) return;

    let allData = [];

    for (const attr of dataAttributes) {
      if (resource.attr(attr.name)) {
        chartData[attr.name] = resource.attr(attr.name).resources().list()
          .slice()
          .reverse()
          .map(r => mapResourceToChartDataPoint(r, attr.xAttr, attr.yAttr));

        allData = allData.concat(chartData[attr.name]);
      }
    }

    const timeScale = scaleTime().domain(extent(allData, d => d.x));

    xAxisArgs = {
      ...xAxisArgs,
      domain: timeScale.domain().map(time => time.valueOf()),
      scale: timeScale,
      ticks: timeScale.ticks(5),
      tickFormatter: timeScale.tickFormat(),
    };

    const valueScale = scaleLinear().domain(extent(allData, d => d.y)).nice();
    yAxisArgs = {
      ...yAxisArgs,
      domain: valueScale.domain(),
      scale: valueScale,
      ticks: valueScale.ticks(5),
    };
  }

  processData();

  return {
    chartData,
    xAxisArgs,
    yAxisArgs,
  };
}
